import { useEffect, useState } from 'react';
import { getEnterPriseIframeEncryptedInfoApi } from '../api';

const useEncryptedInfo = props => {
  const { info } = props;
  const [encryptInfo, setEncryptInfo] = useState('');
  const handleGetEncryptInfo = () => {
    setEncryptInfo('');
    getEnterPriseIframeEncryptedInfoApi(info).then(res => {
      if (res && res.data) {
        setEncryptInfo(res.data);
      }
    });
  };
  useEffect(() => {
    handleGetEncryptInfo();
  }, [info]);
  return { encryptInfo };
};

export default useEncryptedInfo;
